import { client } from '../client';
import { ITags } from './listAllTags';

export const getTagsByUserId = async (user_id: number): Promise<ITags[]> => {
  const { data } = await client.get(`/users/${user_id}/tags`);

  return data;
};
